import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Price.module.scss';
import formatPrice from '../../utils/strings/formatPrice';
import stringToNumber from '../../utils/strings/stringToNumber';
/*
 * Compare two prices
 * @param {Number} compareAtPrice
 * @param {Number/String} price
 * @return {Boolean} if the prices are the same
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var displayCAP = function displayCAP(compareAtPrice, price) {
  return stringToNumber(compareAtPrice) > stringToNumber(price);
};

var Price = function Price(_ref, context) {
  var className = _ref.className,
      compareAtPrice = _ref.compareAtPrice,
      lowHigh = _ref.lowHigh,
      price = _ref.price;
  var currency = context.currency;
  var formattedPrice = formatPrice(price, currency);
  var formattedCAP = compareAtPrice ? formatPrice(compareAtPrice, currency) : '';
  var showCAP = compareAtPrice && displayCAP(compareAtPrice, price);
  var capLabel = showCAP ? " Original price ".concat(formattedCAP, ".") : '';
  var priceLabel = price ? "Price ".concat(formattedPrice, ".") : '';
  var ariaLabel = "".concat(priceLabel).concat(capLabel);

  if (showCAP) {
    return /*#__PURE__*/_jsxs("div", {
      "aria-label": ariaLabel,
      className: cc([className, css.root, _defineProperty({}, css.flip, lowHigh)]),
      children: [/*#__PURE__*/_jsx("s", {
        "aria-hidden": "true",
        className: cc([css.compareAtPrice, _defineProperty({}, css.marginal, lowHigh)]),
        children: formattedCAP
      }), price !== undefined && /*#__PURE__*/_jsxs(_Fragment, {
        children: [" ", formattedPrice]
      })]
    });
  }

  return /*#__PURE__*/_jsx("div", {
    "aria-label": ariaLabel,
    className: cc([className, css.root]),
    children: formattedPrice
  });
};

Price.contextTypes = {
  currency: PropTypes.string
};
Price.displayName = 'Price';
Price.defaultProps = {
  className: '',
  compareAtPrice: 0,
  lowHigh: false
};
Price.propTypes = {
  className: PropTypes.string,
  compareAtPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lowHigh: PropTypes.bool,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default Price;